import { render, staticRenderFns } from "./GrupoLigaRodada.vue?vue&type=template&id=5a1469d0&scoped=true"
import script from "./GrupoLigaRodada.vue?vue&type=script&lang=js"
export * from "./GrupoLigaRodada.vue?vue&type=script&lang=js"
import style0 from "./GrupoLigaRodada.vue?vue&type=style&index=0&id=5a1469d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1469d0",
  null
  
)

export default component.exports